// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";

function getVm(driverTerminationData) {
  return List.map((function (terminationRecord) {
                return {
                        admin: terminationRecord.terminationAdmin,
                        description: terminationRecord.terminationDescription,
                        duration: terminationRecord.terminationDuration,
                        endTime: terminationRecord.terminationEndTime,
                        startTime: terminationRecord.terminationStartTime,
                        comment: terminationRecord.comment,
                        status: terminationRecord.terminationStatus
                      };
              }), driverTerminationData.driverTerminationHistory);
}

var DriverTerminationListVMMapper = {
  getVm: getVm
};

export {
  DriverTerminationListVMMapper ,
  
}
/* No side effect */
